import axios from 'axios';

export type GetPensioenbijEventsArgs = {
  page?: number;
  pageSize?: number;
  status?: string[];
  searchQuery?: string;
};

export type ResendPensioenbijEventsArgs = {
  connectionId: string | null;
  mutationIds: string[];
};

export const toolsServices = {
  async getPensioenbijEvents({ page, pageSize, status, searchQuery }: GetPensioenbijEventsArgs) {
    return axios.get(`connections/mutations`, { params: { page, pageSize, status, searchQuery } });
  },

  async resendPensioenbijEvents({ connectionId, mutationIds }: ResendPensioenbijEventsArgs) {
    return axios.post(`connections/mutations`, { connectionId, mutationIds });
  },
};
